"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.defaultiLabelVisualisationData = exports.iLabelVisualisationTypes = exports.iLabelType = void 0;
var iLabelType;
(function (iLabelType) {
    iLabelType[iLabelType["NODE"] = 1] = "NODE";
    iLabelType[iLabelType["RELATION"] = 2] = "RELATION";
    iLabelType[iLabelType["DOMAIN"] = 3] = "DOMAIN";
})(iLabelType = exports.iLabelType || (exports.iLabelType = {}));
;
/**
 * @description fixed values for visualisation representation
 *
 * @export
 * @enum {number}
 */
var iLabelVisualisationTypes;
(function (iLabelVisualisationTypes) {
    iLabelVisualisationTypes["Circle"] = "_CIRCLE_";
    iLabelVisualisationTypes["Rectangle"] = "_RECTANGLE_";
    iLabelVisualisationTypes["Triagle"] = "_TRIANGLE_";
    iLabelVisualisationTypes["Icon"] = "_ICON_";
})(iLabelVisualisationTypes = exports.iLabelVisualisationTypes || (exports.iLabelVisualisationTypes = {}));
/**
 * @description default visualisation settings of a node to be used.
 */
exports.defaultiLabelVisualisationData = {
    color: "#F6BF26",
    type: iLabelVisualisationTypes.Circle
};
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiTGFiZWwuanMiLCJzb3VyY2VSb290IjoiIiwic291cmNlcyI6WyIuLi8uLi8uLi8uLi9zcmMvcHVibGljL2ludGVyZmFjZXMvTGFiZWwudHMiXSwibmFtZXMiOltdLCJtYXBwaW5ncyI6Ijs7O0FBa0VBLElBQVksVUFJWDtBQUpELFdBQVksVUFBVTtJQUNwQiwyQ0FBUSxDQUFBO0lBQ1IsbURBQVksQ0FBQTtJQUNaLCtDQUFVLENBQUE7QUFDWixDQUFDLEVBSlcsVUFBVSxHQUFWLGtCQUFVLEtBQVYsa0JBQVUsUUFJckI7QUFBQSxDQUFDO0FBRUY7Ozs7O0dBS0c7QUFDSCxJQUFZLHdCQUtYO0FBTEQsV0FBWSx3QkFBd0I7SUFDbEMsK0NBQW1CLENBQUE7SUFDbkIscURBQXlCLENBQUE7SUFDekIsa0RBQXNCLENBQUE7SUFDdEIsMkNBQWUsQ0FBQTtBQUNqQixDQUFDLEVBTFcsd0JBQXdCLEdBQXhCLGdDQUF3QixLQUF4QixnQ0FBd0IsUUFLbkM7QUFtQkQ7O0dBRUc7QUFDVSxRQUFBLDhCQUE4QixHQUFHO0lBQzVDLEtBQUssRUFBRSxTQUFTO0lBQ2hCLElBQUksRUFBRSx3QkFBd0IsQ0FBQyxNQUFNO0NBQ3RDLENBQUMifQ==